import IAssetProvider from 'shared/libraries/mwc/3d/nodeGraph/IAssetProvider';
import { AssetType } from './AssetManager';

type Cache = {
    assets3d: any[],
    materials: any[],
    procedural: any[],
    paths: any[]
}

export default class ParametricFixtureAssetProvider extends IAssetProvider {
    private caches: Cache = {
        assets3d: [],
        materials: [],
        procedural: [],
        paths: []
    };

    constructor() {
        super();
    }

    resetCaches() {
        this.caches = {
            assets3d: [],
            materials: [],
            procedural: [],
            paths: []
        };
    }

    getNodeGraphList() {
        if (!this.caches.procedural || this.caches.procedural.length === 0) {
            this.caches.procedural = window.assetManager.getAssetsOfType(AssetType.Procedural)
                .map(asset => ParametricFixtureAssetProvider.convertToBaseAsset(asset));
        }

        return this.caches.procedural;
    }

    get3DAssetList() {
        if (!this.caches.assets3d || this.caches.assets3d.length === 0) {
            this.caches.assets3d = window.assetManager.getAssetsOfType(AssetType.Fixture)
                .map(asset => ParametricFixtureAssetProvider.convertToBaseAsset(asset));
        }

        return this.caches.assets3d;
    }

    getPathList() {
        if (!this.caches.paths || this.caches.paths.length === 0) {
            this.caches.paths = window.assetManager.getAssetsOfType(AssetType.Profile)
                .map(asset => ParametricFixtureAssetProvider.convertToBaseAsset(asset));
        }

        return this.caches.paths;
    }

    getMaterialList() {
        if (!this.caches.materials || this.caches.materials.length === 0) {
            this.caches.materials = window.assetManager.getAssetsOfType(AssetType.Material)
                .map(asset => ParametricFixtureAssetProvider.convertToBaseAsset(asset));
        }

        return this.caches.materials;
    }

    static convertToBaseAsset(asset) {
        const haveData = !!asset.data && (asset.data.length === undefined || asset.data.length > 0);
        return {
            key: asset.id,
            label: asset.name,
            tagsArray: asset.tags,
            file: asset.babylon_filename ? asset.babylon_filename : asset.json_filename,
            extraModelInfo: haveData ? { data: asset.data } : null,
            levels_of_detail: asset.levels_of_detail,
            metadata: asset.metadata,
        };
    }
}
